// Home.jsx
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

import burger from './assets/burger2.png';
import icon7 from './assets/apt_logo.png'; // COMMUNITY WELL 로고 (파트너 줄)
import kbLogo from './assets/kb.jpg';
import hanaLogo from './assets/hana.png';
import imLogo from './assets/im.png';
import fssLogo from './assets/금감원.jpeg';
import knuLogo from './assets/KNU.jpg';
import laurel from './assets/laurel-wreath.png';
import kbAiChallengeThumb from './assets/kb_aichallenge_2026.jpg';

// 스팸 수집기가 소스에서 주소를 긁어가지 못하도록 인코딩해 두고 런타임에 조립한다
const CONTACT_EMAIL = atob('c2VtaW4yMDcxQGdtYWlsLmNvbQ==');
// FormSubmit 활성화 시 발급되는 고유 문자열. 채워 넣으면 메일 주소 대신 이 주소로 전송된다
const FORM_ALIAS = '';
const FORM_ENDPOINT = `https://formsubmit.co/ajax/${FORM_ALIAS || CONTACT_EMAIL}`;

export default function Home() {
  const heroRef = useRef(null);
  const servicesRef = useRef(null);
  const contactRef = useRef(null);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [activeNav, setActiveNav] = useState('Home');
  const [showQuote, setShowQuote] = useState(false);
  const [quoteForm, setQuoteForm] = useState({ name: '', phone: '', email: '', message: '', _honey: '' });
  const [quoteStatus, setQuoteStatus] = useState('idle'); // idle | sending | sent | error
  const [activeDemo, setActiveDemo] = useState(null);
  const navigate = useNavigate();

  // 라이브 데모(실제 프론트엔드를 NewHome에 정적 내장) 목록
  const demos = [
    { key: 'imbank', title: 'iM금융그룹', subtitle: 'by SC · Live Demo', src: '/imbank/index.html' },
    { key: 'hana', title: '하나금융그룹', subtitle: 'by SC · Live Demo', src: '/hana/index.html' },
    { key: 'logical', title: 'Logical.AI', subtitle: '모두의 창업 솔루션 · 기업 참여 서비스', src: '/logical/index.html' },
    { key: 'brandfactory', title: 'Brand Factory', subtitle: 'brand-factory.app · 모두의 창업 2기', src: 'https://brand-factory.app/' },
    { key: 'eazybuilder', title: 'Eazy Builder', subtitle: 'eazy-builder.app · 모두의 창업 2기', src: 'https://eazy-builder.app/' },
    { key: 'icfss', title: 'International Conference', subtitle: 'icfss.co.kr · Live Site', src: 'https://icfss.co.kr/' },
    { key: 'kbdatory', title: 'KB AI CHALLENGE', subtitle: 'by SC · Live Demo', src: '/kbdatory/index.html' },
    // kb-aichallenge.com은 X-Frame-Options: SAMEORIGIN → iframe 임베드 불가, 포스터 썸네일 + 새 탭으로 열기
    { key: 'kbaichallenge2026', title: '2026 KB AI Challenge', subtitle: 'kb-aichallenge.com · Live Site', src: 'https://kb-aichallenge.com/', embed: false, thumb: kbAiChallengeThumb },
    { key: 'korinmex', title: 'KOR-IN-MEX', subtitle: 'kor-in-mex.com · Live Site', src: 'https://www.kor-in-mex.com/' },
    { key: 'linkpoket', title: 'LINKPOKET', subtitle: 'linkpoket.com · Live Site', src: 'https://linkpoket.com/' },
    { key: '50judges', title: '50 Judges', subtitle: '50judges.co.kr · Live Site', src: 'https://50judges.co.kr/' },
    { key: 'madam4060', title: 'Madam 4060', subtitle: 'madam4060.com · Live Site', src: 'https://www.madam4060.com/' },
    // community-well은 X-Frame-Options: DENY → iframe 임베드 불가, 새 탭으로 열기
    { key: 'danzien', title: 'DANZIEN', subtitle: 'danzien.co.kr · Live Site', src: 'https://www.danzien.co.kr/' },
    { key: 'communitywell', title: 'COMMUNITY WELL', subtitle: 'community-well.co.kr · Live Site', src: 'https://community-well.co.kr/', embed: false },
    { key: 'verable', title: 'verable', subtitle: 'drinkverable.com · Live Site', src: 'https://drinkverable.com/' },
  ];

  // 수상/선정 내역
  const awards = [
    { date: '2022.03', name: 'Stop-Covid-19 SW Challenge', result: '3rd' },
    { date: '2022.12', name: 'Global AI 2022', result: '3rd' },
    { date: '2023.06', name: "South Korea's Digital Talent Training Project", result: '2nd' },
    { date: '2023.07', name: 'Daegu City Public Data Utilization Competition', result: 'Grand Prize' },
    { date: '2023.08', name: 'SKT Tech4Good Hackathon', result: 'Idea Prize' },
    { date: '2023.09', name: 'ICT Innovation Square AI Hackathon', result: '4th' },
    { date: '2023.12', name: '2nd Digital Talent Training Project in Korea', result: 'Grand Prize' },
    { date: '2024.12', name: 'Kyungpook National University Startup Competition', result: 'Best Prize' },
    { date: '2025.02', name: 'KNU Technology Startup Boot Camp', result: 'Best Award' },
    { date: '2025.07', name: 'University Startup Idea Challenge', result: 'Creativity Award (Daegu Regional 1st)' },
    { date: '2025.08', name: 'ICT Innovation Square Startup Competition', result: '2nd' },
    { date: '2025.08', name: 'Daegu Tourism Startup Idea Contest', result: '1st' },
    { date: '2025.11', name: 'ICT Innovation Championship Game', result: 'Grand Prize' },
    { date: '2025.12', name: 'Kyungpook National University Startup Competition', result: 'Best Prize' },
    { date: '2026.01', name: 'KNU Career Club Achievement Report Competition', result: 'Best Award' },
    { date: '2026.01', name: "KNU Startup Competition 'Next Venture Challenge'", result: '3rd' },
    { date: '2026.01', name: 'Global Startup Competition', result: 'Finalist' },
    { date: '2026.03', name: 'MIT GSW (Global Startup Workshop)', result: 'Finalist' },
    { date: '2026.08', name: 'G-STAR PITCHDAY Preliminary Round', result: '2nd (Excellence Award)' },
  ];

  // 'domain · kind' 형태의 subtitle을 캡션 두 줄로 분리
  const splitSubtitle = (subtitle = '') => {
    const [eyebrow, ...rest] = subtitle.split('·').map(part => part.trim());
    return { eyebrow, meta: rest.join(' · ') };
  };

  // 견적 문의 팝업: ESC로 닫기 + 열려 있는 동안 배경 스크롤 잠금
  useEffect(() => {
    if (!showQuote) return undefined;
    const onKeyDown = (e) => e.key === 'Escape' && setShowQuote(false);
    document.addEventListener('keydown', onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [showQuote]);

  const openQuote = () => {
    setQuoteStatus('idle');
    setShowQuote(true);
  };

  const handleQuoteChange = (e) => {
    const { name, value } = e.target;
    setQuoteForm(prev => ({ ...prev, [name]: value }));
  };

  const handleQuoteSubmit = async (e) => {
    e.preventDefault();
    if (quoteStatus === 'sending') return;
    setQuoteStatus('sending');
    try {
      const res = await fetch(FORM_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          _subject: `[SC 견적 문의] ${quoteForm.name || '이름 미기재'}`,
          _template: 'table',
          _captcha: 'false',
          성함: quoteForm.name,
          연락처: quoteForm.phone,
          이메일: quoteForm.email,
          문의내용: quoteForm.message,
          _honey: quoteForm._honey,
        }),
      });
      const data = await res.json().catch(() => ({}));
      // FormSubmit은 폼 활성화 전이나 검증 실패 시에도 200을 주므로 success 값까지 확인한다
      if (!res.ok || String(data.success) !== 'true') {
        throw new Error(data.message || `HTTP ${res.status}`);
      }
      setQuoteStatus('sent');
      setQuoteForm({ name: '', phone: '', email: '', message: '', _honey: '' });
    } catch (err) {
      setQuoteStatus('error');
    }
  };

  const handleNavClick = (section) => {
    setShowMobileMenu(false);
    setActiveNav(section);
    switch (section) {
      case 'Home': window.scrollTo({ top: 0, behavior: 'smooth' }); break;
      case 'Services': servicesRef.current.scrollIntoView({ behavior: 'smooth' }); break;
      case 'Contact': contactRef.current.scrollIntoView({ behavior: 'smooth' }); break;
      case 'About': navigate('/about'); break;
      default: break;
    }
  };

  return (
    <main className="container">
      {/* Hero 섹션 */}
      <section className="hero" ref={heroRef}>
        <nav className="nav">
          <h1>SC</h1>
          <ul>
            {['Home', 'Services', 'About'].map(item => (
              <li
                key={item}
                className={activeNav === item ? 'is-active' : ''}
                onClick={() => handleNavClick(item)}
              >
                {item}
              </li>
            ))}
            <li className="nav-cta" onClick={() => handleNavClick('Contact')}>Contact</li>
          </ul>
          <div className="menu-icon" onClick={() => setShowMobileMenu(prev => !prev)}>
            <img src={burger} alt="menu" className="menu-icon-img" />
          </div>
          {showMobileMenu && (
            <ul className="mobile-menu">
              {['Home', 'Services', 'About', 'Contact'].map(item => (
                <li key={item} onClick={() => handleNavClick(item)}>{item}</li>
              ))}
            </ul>
          )}
        </nav>

        <div className="hero-content">
          <div className="hero-heading">
            <span className="hero-rule" />
            <h2 className="hero-title">
              <span>We design</span>
              <span>free and trendy world</span>
            </h2>
            <span className="hero-rule" />
          </div>

          <p className="hero-tagline">A creative studio for a free and trendy world</p>

          <div className="hero-statement">
            <p>WEB &middot; APP &middot; AI PRODUCT DESIGN AND DEVELOPMENT</p>
            <p>Selected Works | 2022 &mdash; 2026.</p>
          </div>

          <div className="hero-partners">
            <span className="hero-partners-label">PARTNER / CLIENT</span>
            <ul>
              <li><img src={fssLogo} alt="FSS" className="partner-logo" /></li>
              <li><img src={kbLogo} alt="KB금융그룹" className="partner-logo" /></li>
              <li><img src={hanaLogo} alt="하나금융그룹" className="partner-logo" /></li>
              <li><img src={imLogo} alt="IM금융그룹" className="partner-logo" /></li>
              <li><img src={knuLogo} alt="KNU" className="partner-logo" /></li>
              <li><img src={icon7} alt="COMMUNITY WELL" className="partner-logo" /></li>
            </ul>
          </div>
          <button
            className="hero-more"
            onClick={() => servicesRef.current?.scrollIntoView({ behavior: 'smooth' })}
          >
            MORE
          </button>
        </div>
      </section>

      {/* Services 섹션 */}
      <section ref={servicesRef}>
        <div className="services-header">
          <span className="section-label">Portfolio</span>
          <h1 className="service-title">Webpages</h1>
        </div>

        {/* 라이브 데모 카드 - 클릭 시 실제 프론트엔드를 크게 보여줌 */}
        <div className="showcase">
          {demos.map((demo) => {
            const { eyebrow, meta } = splitSubtitle(demo.subtitle);
            const preview = (
              <div className="showcase-preview">
                <img
                  src={demo.thumb || `/thumbs/${demo.key}.jpg`}
                  alt={`${demo.title} 미리보기`}
                  className="showcase-thumb"
                  loading="lazy"
                />
                <span className="showcase-overlay">
                  {demo.embed === false ? 'Visit Site ↗' : 'Open Live View'}
                </span>
              </div>
            );

            return (
              <div className="showcase-item" key={demo.key}>
                {demo.embed === false ? (
                  <a
                    className="showcase-card showcase-card--link"
                    href={demo.src}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {preview}
                  </a>
                ) : (
                  <div
                    className="showcase-card"
                    onClick={() => setActiveDemo(demo)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setActiveDemo(demo)}
                  >
                    {preview}
                  </div>
                )}
                <div className="showcase-caption">
                  {eyebrow && <span className="showcase-eyebrow">{eyebrow}</span>}
                  <strong>{demo.title}</strong>
                  {meta && <span className="showcase-meta">{meta}</span>}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Award 섹션 */}
      <section className="award-section">
        <h2 className="award-title"><img src={laurel} alt="" className="award-laurel" />AWARDS</h2>
        <p className="award-sub">선정 · 수상 및 노미네이트 내역</p>

        <div className="awards-table">
          <div className="awards-row awards-head">
            <span>대회명</span>
            <span>날짜</span>
            <span>결과</span>
          </div>
          {awards.map((a, i) => (
            <div className="awards-row" key={i}>
              <span className="awards-name">{a.name}</span>
              <span className="awards-date">{a.date}</span>
              <span className="awards-result">{a.result}</span>
            </div>
          ))}
        </div>
      </section>

      {/* 외주 개발 문의 CTA */}
      <section className="cta-section">
        <h2 className="cta-title" style={{ display: 'none' }}>외주 개발이 필요하신가요?</h2>
        <button type="button" className="cta-btn" onClick={openQuote}>
          Contact
        </button>
      </section>

      {/* Contact 섹션 */}
      <section className="clients" ref={contactRef}>
        <button onClick={openQuote}>Contact Us</button>
        <h5>© {new Date().getFullYear()} Inc. SC. All rights reserved.</h5>
      </section>

      {/* 견적 문의 팝업 */}
      {showQuote && (
        <div className="quote-modal" onClick={() => setShowQuote(false)}>
          <div
            className="quote-panel"
            role="dialog"
            aria-modal="true"
            aria-labelledby="quote-title"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="quote-close" onClick={() => setShowQuote(false)} aria-label="닫기">✕</button>
            <span className="quote-eyebrow">Contact</span>
            <h3 className="quote-title" id="quote-title">견적 문의</h3>

            {quoteStatus === 'sent' ? (
              <div className="quote-done">
                <p className="quote-done-title">문의가 접수되었습니다.</p>
                <p className="quote-done-text">
                  남겨주신 연락처로 영업일 기준 1~2일 내에 회신드리겠습니다.
                </p>
                <button type="button" className="quote-submit" onClick={() => setShowQuote(false)}>
                  닫기
                </button>
              </div>
            ) : (
              <form className="quote-form" onSubmit={handleQuoteSubmit}>
                <label className="quote-field">
                  <span>성함 *</span>
                  <input
                    type="text"
                    name="name"
                    value={quoteForm.name}
                    onChange={handleQuoteChange}
                    placeholder="홍길동"
                    autoComplete="name"
                    required
                  />
                </label>
                <label className="quote-field">
                  <span>연락처 *</span>
                  <input
                    type="tel"
                    name="phone"
                    value={quoteForm.phone}
                    onChange={handleQuoteChange}
                    placeholder="010-0000-0000"
                    autoComplete="tel"
                    required
                  />
                </label>
                <label className="quote-field">
                  <span>이메일 *</span>
                  <input
                    type="email"
                    name="email"
                    value={quoteForm.email}
                    onChange={handleQuoteChange}
                    placeholder="you@example.com"
                    autoComplete="email"
                    required
                  />
                </label>
                <label className="quote-field">
                  <span>문의 내용</span>
                  <textarea
                    name="message"
                    value={quoteForm.message}
                    onChange={handleQuoteChange}
                    rows={4}
                    placeholder="필요하신 작업, 일정, 예산 범위를 적어주시면 더 정확한 견적을 드릴 수 있습니다."
                  />
                </label>
                {/* 스팸 봇 트랩: 사람에게는 보이지 않는다 */}
                <input
                  type="text"
                  name="_honey"
                  value={quoteForm._honey}
                  onChange={handleQuoteChange}
                  className="quote-honey"
                  tabIndex={-1}
                  autoComplete="off"
                />

                {quoteStatus === 'error' && (
                  <p className="quote-error">
                    전송에 실패했습니다. 잠시 후 다시 시도하시거나{' '}
                    <a href={`mailto:${CONTACT_EMAIL}?subject=외주 개발 문의`}>메일로 보내주세요</a>.
                  </p>
                )}

                <button type="submit" className="quote-submit" disabled={quoteStatus === 'sending'}>
                  {quoteStatus === 'sending' ? '보내는 중…' : '보내기'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* 라이브 데모 모달 */}
      {activeDemo && (
        <div className="demo-modal" onClick={() => setActiveDemo(null)}>
          <div className="demo-modal-head">
            <span>{activeDemo.title} — Live Demo</span>
            <button className="demo-close" onClick={() => setActiveDemo(null)}>✕</button>
          </div>
          <div className="demo-frame" onClick={(e) => e.stopPropagation()}>
            <iframe src={activeDemo.src} title={`${activeDemo.title} 라이브 데모`} />
          </div>
        </div>
      )}
    </main>
  );
}